import * as React from 'react';
import { noop } from '@cian/newbuilding-utils';
import { Header3, Image, Paragraph2 } from '@cian/ui-kit';
import { ButtonLink } from '../../../ButtonLink';

import * as styles from './styles.css';

interface IAdvantageItemProps {
  title: string;
  shortDescription: string;
  imgUrl?: string;
}

export function InteriorDecorationItem({ title, imgUrl, shortDescription }: IAdvantageItemProps) {
  return (
    <div className={styles['container']}>
      <div className={styles['image']}>
        {!!imgUrl && <Image src={imgUrl} width="100%" height="100%" objectFit="cover" borderRadius="4px" />}
      </div>
      <div className={styles['title']}>
        <Header3 as="h3">{title}</Header3>
      </div>
      {shortDescription && (
        <div className={styles['description']}>
          <Paragraph2>{shortDescription}</Paragraph2>
        </div>
      )}
      <ButtonLink onClick={noop}>Узнать больше</ButtonLink>
    </div>
  );
}
